// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BeBeRoVFkdADi4E8{border-radius:1000px}.h_voR2E7aDwZ2HiF{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.LX7JQu3MCPEnyKwP{display:flex;flex-direction:column;justify-content:center;align-items:center}.Kv1vOCQgakCO5kir{animation:gzJehoda2D4lvabm 3s infinite;animation-iteration-count:infinite}@keyframes gzJehoda2D4lvabm{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.jYq_RIX7wTQm0cpk{border-top:1px solid var(--py-neutral-2);padding:24px 56px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `BeBeRoVFkdADi4E8`,
	"text-truncate": `h_voR2E7aDwZ2HiF`,
	"shaquille": `LX7JQu3MCPEnyKwP`,
	"shimmer": `Kv1vOCQgakCO5kir`,
	"placeHolderShimmer": `gzJehoda2D4lvabm`,
	"reportBuilderContainer": `jYq_RIX7wTQm0cpk`
};
export default ___CSS_LOADER_EXPORT___;
